module.exports = __webpack_public_path__ + "media/images/guidelines/video_share@2x-2bf6daa8609fb3010e532299dedfce9e.png";